export default "__VITE_ASSET__Bmbk$zvQ__"